import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=b55c5d1e&"
import script from "./AppDashboard.vue?vue&type=script&lang=js&"
export * from "./AppDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports